import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { State } from "../state";
import { FilterBasedAccessor } from "./FilterBasedAccessor";
import { BoolMust, FilterBucket } from "../query";

var assign = require("lodash/assign");

export var CheckboxFilterAccessor =
/*#__PURE__*/
function (_FilterBasedAccessor) {
  _inherits(CheckboxFilterAccessor, _FilterBasedAccessor);

  function CheckboxFilterAccessor(key, options) {
    var _this;

    _classCallCheck(this, CheckboxFilterAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckboxFilterAccessor).call(this, key, options.id));
    _this.state = new State(false);
    _this.options = options;
    _this.filter = options.filter;
    _this.state = _this.state.create(options.defaultValue);
    _this.translations = assign({}, options.translations);
    return _this;
  }

  _createClass(CheckboxFilterAccessor, [{
    key: "getDocCount",
    value: function getDocCount() {
      return this.getAggregations([this.uuid, "doc_count"], 0);
    }
  }, {
    key: "buildSharedQuery",
    value: function buildSharedQuery(query) {
      var _this2 = this;

      if (this.state.getValue()) {
        query = query.addFilter(this.uuid, this.filter).addSelectedFilter({
          name: this.options.title || this.translate(this.key),
          value: this.options.label || this.translate("checkbox.on"),
          id: this.options.id,
          remove: function remove() {
            return _this2.state = _this2.state.setValue(false);
          }
        });
      }

      return query;
    }
  }, {
    key: "buildOwnQuery",
    value: function buildOwnQuery(query) {
      var filters = query.getFilters();

      if (!this.state.getValue()) {
        if (filters) filters = BoolMust([filters, this.filter]);else filters = this.filter;
      }

      return query.setAggs(FilterBucket(this.uuid, filters));
    }
  }]);

  return CheckboxFilterAccessor;
}(FilterBasedAccessor);
CheckboxFilterAccessor.translations = {
  "checkbox.on": "active"
};